import { useInvoiceReportMultipleSortByDatetimeFlag } from '@/hooks/feature_flag/useInvoiceReportMultipleSortByDatetimeFlag';
import { useCallback, useMemo } from 'react';

/**
 * AC1 (NA-5478): the invoice-report date columns (作成日/申請日/承認日) show the
 * time on a 2nd line only for the column currently being sorted, and only while
 * the `invoice-report-multiple-sort-by-datetime` flag is on.
 *
 * Shared by the list/admin/approving column definitions so the behavior stays
 * in sync. Returns a stable `isTimeVisibleForColumn(columnKey)` predicate to
 * feed into `<DateTimeCell showTime={...} />`.
 */
export const useIsTimeVisibleForColumn = <T extends { columnKey: string }>(
  sortOrders?: T[]
): ((columnKey: string) => boolean) => {
  const displayDatetimeFlag = useInvoiceReportMultipleSortByDatetimeFlag();
  const sortedColumnKeys = useMemo(
    () => new Set((sortOrders ?? []).map((s) => s.columnKey)),
    [sortOrders]
  );
  return useCallback(
    (columnKey: string) =>
      displayDatetimeFlag && sortedColumnKeys.has(columnKey),
    [displayDatetimeFlag, sortedColumnKeys]
  );
};
